import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import TableIncomeAndExpense from '../../mainIncomAndExpenseWidgets/TableIncomeAndExpense'
import {
  getAllProjectAcc,
  getAllProjectAssetClose,
  searchAllProjectAcc,
  searchAllProjectAssetClose,
} from '../../../redux/actions/dashboard'
import TableLoadingTemplate from '../../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import notification from '../../../utils/notification'
import { SEARCH_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash-es'

export default function AssetCloseProject() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      //const response = await getAllProjectAssetClose(1, 5)
      //setSchema(response)
      setSchema(mock)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  const handleSearch = async (pagenumber = 1, pagesize = 5, request, notSetBody) => {
    // console.log('handleSearch ', pagenumber, pagesize)
    setIsLoading(true)

    try {
      if (!notSetBody) {
        setRequestBody(request)
      }

      const response = await searchAllProjectAssetClose(pagenumber, pagesize, request)

      if (response) {
        var _schema = cloneDeep(schema)
        _schema.datas = response

        setSchema(_schema)
      }
    } catch (e) {
      // console.log('error ', e)
      // setError({})
      notification.open('success', {
        title: SEARCH_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <Panel
          shaded
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 15 }}
        >
          <TableIncomeAndExpense schema={schema} loading={isLoading} onSearch={handleSearch} />
        </Panel>
      )}
    </>
  )
}

const mock = {
  header: 'โครงการที่รอตรวจสอบครุภัณฑ์ปิดโครงการ',
  userRole: 0,
  searchForm: {
    projectCode: { name: 'projectCode', label: 'รหัสโครงการ', value: '' },
    projectName: { name: 'projectName', label: 'ชื่อโครงการ', value: '' },
    contractNumber: null,
    grantree: null,
    codinator: null,
    responsinator: null,
  },
  datas: {
    totalSize: 5,
    values: [
      {
        projectId: '5E6ACE29-4E5C-4745-9851-23F9E3C37A14',
        projectCode: '66-00018',
        isDisplayWarning: null,
        countStatusStickyNote: 0,
        projectName: 'ทดสอบอนุมัติหลายโครงการ 002',
        contractNo: '66-P1-0011',
        periodNum: '3',
        budget: 1090000.0,
        budgetReceipt: 4000000.0,
        projectStatus: 'ดำเนินการ',
        assetRegister: 'มีคำขอขึ้นทะเบียน',
        assetClosure: null,
        totalSize: 5,
        pathName: '/durable-articles/history',
      },
      {
        projectId: 'F237B4E4-FDF1-473D-89B9-030F6B29E603',
        projectCode: '64-00574',
        isDisplayWarning: null,
        countStatusStickyNote: 0,
        projectName: 'เด็กฉลาด รายงานการเงิน 2',
        contractNo: 'C64-00080',
        periodNum: '2',
        budget: 1200000.0,
        budgetReceipt: 0.0,
        projectStatus: 'ปิดโครงการ',
        assetRegister: null,
        assetClosure: null,
        totalSize: 5,
        pathName: '/durable-articles/history',
      },
      {
        projectId: '42FA9725-3554-4FAD-9F60-8440EAE985CF',
        projectCode: '65-00018',
        isDisplayWarning: null,
        countStatusStickyNote: 0,
        projectName: 'การพัฒนาศักยภาพผู้สูงอายุเพิ่มทักษะ ฟื้นฟูทักษะ ลดการพึ่งพาจากสังคม 340',
        contractNo: '65-P2-0022',
        periodNum: '3',
        budget: 1400000.0,
        budgetReceipt: 0.0,
        projectStatus: 'ดำเนินการ',
        assetRegister: 'มีคำขอขึ้นทะเบียน',
        assetClosure: 'มีคำขอครุภัณฑ์ปิดโครงการ',
        totalSize: 5,
        pathName: '/durable-articles/history',
      },
      {
        projectId: 'B73C28AD-2E2E-46FA-902D-8E6D9DBF0937',
        projectCode: '66-00014',
        isDisplayWarning: null,
        countStatusStickyNote: 0,
        projectName: 'ทดสอบ อนุมัติ 2023-4 - แก้สัญญา',
        contractNo: '66-P1-0008',
        periodNum: '4',
        budget: 2250000.0,
        budgetReceipt: 2250000.0,
        projectStatus: 'ดำเนินการ',
        assetRegister: null,
        assetClosure: null,
        totalSize: 5,
        pathName: '/durable-articles/history',
      },
      {
        projectId: '892291D4-8A02-46C0-9EE8-F041DE0CCEA2',
        projectCode: '65-00023',
        isDisplayWarning: null,
        countStatusStickyNote: 0,
        projectName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน 11',
        contractNo: '65-E1-0027',
        periodNum: '3',
        budget: 4000000.0,
        budgetReceipt: 300000.0,
        projectStatus: 'ดำเนินการ',
        assetRegister: null,
        assetClosure: null,
        totalSize: 5,
        pathName: '/durable-articles/history',
      },
    ],
  },
}
